import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link, NavLink } from "react-router-dom";

import "./top_bar.less";

import Dropdown from "@ui/dropdown";

import { logOut } from "../../actions/session";

import UserAvatar from "./settings/sections/user_avatar";

const TopBar = ({ currentOrganization, currentUser, logOut }) => {
  const { can_manage_offline_batches, can_view_categories } = currentUser;
  const isDemystUser = currentOrganization.id == 2 || currentOrganization.id == 3;

  const items = [
    <NavLink to="/discovery/settings">My Account</NavLink>,
    can_manage_offline_batches && (
      <Link to="/discovery/offline_batches">Offline Batches</Link>
    ),
    can_view_categories && (
      <Link to="/discovery/custom_categories">Custom Categories</Link>
    ),
    <button type="button" onClick={logOut}>
      <b>Logout</b>
    </button>
  ];

  return (
    <div className="TopBar">
      {isDemystUser && (
        <div>
          <a href="/admin">Demyst Admin</a>
        </div>
      )}
      {currentUser && (
        <div>
          <a href="https://platform.demyst.com/products" target="_blank">
            Catalog
          </a>
        </div>
      )}
      {currentUser && (
        <div>
          <a href="https://platform.demyst.com/docs" target="_blank">
            Docs
          </a>
        </div>
      )}
      {currentOrganization.show_discovery_support && (
        <div id="labs-support-button" className="clickable">
          Support
        </div>
      )}
      <Dropdown
        label={
          <>
            <UserAvatar size={37} />
            {currentUser.name}
          </>
        }
        items={items}
      />
    </div>
  );
};

TopBar.propTypes = {
  currentOrganization: PropTypes.shape({
    show_discovery_support: PropTypes.bool.isRequired
  }).isRequired,
  currentUser: PropTypes.shape({
    name: PropTypes.string.isRequired,
    permissions: PropTypes.shape({
      can_manage_offline_batches: PropTypes.bool.isRequired,
      can_view_categories: PropTypes.bool.isRequired
    }).isRequired
  }).isRequired,
  logOut: PropTypes.func.isRequired
};

export default connect(
  store => ({
    currentOrganization: store.session.data.organization,
    currentUser: store.session.data.user
  }),
  { logOut }
)(TopBar);
